module.exports = __webpack_public_path__ + "static/media/WelcomeTeacher.e0521c93.svg";